<template>
    <Icon v-if="icon" class="ui-icon" />
    <slot v-else class="ui-icon" />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import * as icons from '@tabler/icons-vue'

const props = defineProps<{
  size?: number | string
  icon?: string
  strokeWidth?: number | string
}>()

/**
 * Normaliza a largura dos traços do icone
 */
const iconStrokeWidth = computed(() => props.strokeWidth ?? 1.5)

/**
 * Normaliza o tamanho da fonte (inherit caso omisso)
 */
const iconSize = computed(() => {
  if (!props.size) return '1.5em'
  const size = `${props.size}`.toLowerCase().replace(/\s*/, '').match(/(\d+)(px|em|rem|%)?/)
  return `${size[1] || 14}${size[2] || 'px'}`
})

const transformCamelCase = (value: string) => {
  return 'Icon' + value.split('.').at(-1).split('-').map((v) => `${(v[0].toUpperCase() + v.substring(1))}`).join('')
}

const Icon = computed(() => icons[transformCamelCase(props.icon)])
</script>

<style lang="scss" scoped>
.ui-icon {
  height: v-bind(iconSize);
  width: v-bind(iconSize);
  stroke-width: v-bind(iconStrokeWidth);
  vertical-align: middle;
}
</style>
